module.exports = __webpack_public_path__ + "static/passion2-60702bbdad42eaf14d6cb706e1dfb129.jpg";